import {
  autoinject,
  bindable,
  ComponentAttached,
  ComponentDetached,
} from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import {
  Chart,
  ChartConfiguration,
  LinearChartData,
  LinearTickOptions,
  ChartTooltipItem,
  ChartPoint,
} from "chart.js";
import { Pumpe } from "./productfinder-result";

@autoinject
export class KPumpChart implements ComponentAttached, ComponentDetached {
  @bindable pump: Pumpe;
  @bindable canvasId: string;
  chartCanvas: HTMLCanvasElement;

  private chart: Chart;

  constructor(private i18n: I18N) {}

  attached(): void {
    let data: LinearChartData = {
      datasets: [
        {
          data: this.pump.chartPoints,
          fill: false,
          borderColor: "darkblue", // this is the line color
          pointStyle: ["circle", "star", "circle"],
          pointRadius: [5, 10, 5],
          pointBorderColor: "red",
          pointHoverRadius: [7, 13, 7],
        },
      ],
    };

    let axisX_unit = this.i18n.tr("units.drehzahl.rpm");
    let axisY_unit = this.i18n.tr(
      `units.foerderstrom.${this.pump.foerderstromUnit}`,
    );

    let tickOptions: LinearTickOptions = { min: 0, beginAtZero: true };

    let that = this;

    let chartConfiguration: ChartConfiguration = {
      type: "line",
      data: data,
      options: {
        title: {
          display: true,
          text: this.tr("title", { pumpname: this.pump.pumpentyp.text }),
          fontColor: "#333",
          fontSize: 14,
        },
        legend: { display: false },
        animation: undefined,
        scales: {
          xAxes: [
            {
              type: "linear",
              ticks: tickOptions,
              position: "bottom",
              scaleLabel: {
                display: true,
                labelString: this.tr("axisX", { unit: axisX_unit }),
                fontColor: "#333",
              },
            },
          ],
          yAxes: [
            {
              type: "linear",
              ticks: tickOptions,
              scaleLabel: {
                display: true,
                labelString: this.tr("axisY", { unit: axisY_unit }),
                fontColor: "#333",
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            title: (tooltipItem: ChartTooltipItem[], data: LinearChartData) =>
              that.tr("tooltipX", {
                x: (
                  data.datasets![tooltipItem[0].datasetIndex!].data![
                    tooltipItem[0].index!
                  ] as ChartPoint
                ).x,
                unit: axisX_unit,
              }),
            label: (tooltipItem: ChartTooltipItem, data: LinearChartData) =>
              that.tr("tooltipY", {
                y: (
                  data.datasets![tooltipItem.datasetIndex!].data![
                    tooltipItem.index!
                  ] as ChartPoint
                ).y,
                unit: axisY_unit,
              }),
          },
        },
      },
    };

    this.chart = new Chart(this.chartCanvas, chartConfiguration);
  }

  detached(): void {
    this.chart && this.chart.destroy();
  }

  private tr(s: any, args?: any) {
    return this.i18n.tr("productfinder.output.pump.diagram." + s, args);
  }
}
